import RatingPage from '@app-studio-web/ui/pages/RatingPage'
import { Trans, useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function RatingGratefulPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  const constructHeading = () => {
    return (
      <Trans
        i18nKey="pages.onboarding.ratingGrateful.heading"
        components={{ br: <br /> }}
      />
    )
  }

  return (
    <RatingPage
      heading={constructHeading()}
      leftText={t('pages.onboarding.ratingGrateful.leftText')}
      rightText={t('pages.onboarding.ratingGrateful.rightText')}
      onSubmit={handleSubmit}
    />
  )
}
